import { render } from "./PublicOfferPage.vue?vue&type=template&id=5ce117a9&scoped=true"
import script from "./PublicOfferPage.vue?vue&type=script&lang=ts"
export * from "./PublicOfferPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5ce117a9"

export default script